import React from "react";
import { IconSize, IconProps } from "../theme";

const Homestead: React.FC<IconProps> = ({ size = IconSize.M }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame">
        <path
          id="Vector"
          d="M30 25.9998H28V14.4436C28 14.1668 27.9426 13.893 27.8314 13.6395C27.7201 13.3861 27.5575 13.1584 27.3538 12.9711L17.3538 3.53608C17.3489 3.53181 17.3443 3.52722 17.34 3.52233C16.9718 3.18749 16.492 3.00195 15.9944 3.00195C15.4967 3.00195 15.0169 3.18749 14.6488 3.52233L14.635 3.53608L4.64625 12.9711C4.4425 13.1584 4.27985 13.3861 4.16861 13.6395C4.05737 13.893 3.99996 14.1668 4 14.4436V25.9998H2C1.73478 25.9998 1.48043 26.1052 1.29289 26.2927C1.10536 26.4803 1 26.7346 1 26.9998C1 27.265 1.10536 27.5194 1.29289 27.7069C1.48043 27.8945 1.73478 27.9998 2 27.9998H30C30.2652 27.9998 30.5196 27.8945 30.7071 27.7069C30.8946 27.5194 31 27.265 31 26.9998C31 26.7346 30.8946 26.4803 30.7071 26.2927C30.5196 26.1052 30.2652 25.9998 30 25.9998ZM19 25.9998H13V19.9998C13 19.7346 13.1054 19.4803 13.2929 19.2927C13.4804 19.1052 13.7348 18.9998 14 18.9998H18C18.2652 18.9998 18.5196 19.1052 18.7071 19.2927C18.8946 19.4803 19 19.7346 19 19.9998V25.9998Z"
          fill="#071443"
        />
      </g>
    </svg>
  );
};

export default Homestead;
